import page from './page/page'
import mall from './views/mall'

// 路由
export default [
	...page, //主页面
	...mall //C端商城
]
